var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMore = function SvgIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "More",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.188 8.75a2 2 0 1 0-2 2 2.006 2.006 0 0 0 2-2Zm0 12a2 2 0 1 0-2 2 2.006 2.006 0 0 0 2-2Zm0-6a2 2 0 1 0-2 2 2.006 2.006 0 0 0 2-2Z",
    transform: "translate(-9.188 -6.75)",
    "data-no-stroke": "true"
  })));
};
export { SvgIconMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTW9yZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogICAgPHBhdGgKICAgICAgICBkPSJNMTkuMTg4LDguNzVhMiwyLDAsMSwwLTIsMkEyLjAwNiwyLjAwNiwwLDAsMCwxOS4xODgsOC43NVptMCwxMmEyLDIsMCwxLDAtMiwyQTIuMDA2LDIuMDA2LDAsMCwwLDE5LjE4OCwyMC43NVptMC02YTIsMiwwLDEsMC0yLDJBMi4wMDYsMi4wMDYsMCwwLDAsMTkuMTg4LDE0Ljc1WiIKICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOS4xODggLTYuNzUpIgogICAgICAgIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIgogICAgLz4KPC9zdmc+Cg==";